import { render, staticRenderFns } from "./layout-digital-human.vue?vue&type=template&id=0607c1c9&scoped=true"
import script from "./layout-digital-human.vue?vue&type=script&lang=js"
export * from "./layout-digital-human.vue?vue&type=script&lang=js"
import style0 from "./layout-digital-human.vue?vue&type=style&index=0&id=0607c1c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../mnt/host/d/wwwroot/deepcityAI/user-client-pc/user-client-common-pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0607c1c9",
  null
  
)

export default component.exports